import { D365_FORM_API_URL } from '../ComposableForm/ComposableForm.constants'

export { D365_FORM_API_URL }
export { D365_BUNDLE_URL } from '../ComposableForm/ComposableForm.constants'

export const LEAD_FORM_CRM_ID = 'e3a35256-af6b-f111-a826-000d3a673ec0'

export const LEAD_FORM_CHANNEL_TYPE = {
  DataverseFieldName: 'wp_channeltypeid',
  DataverseFieldValue:
    '{"Id":"1ab713e9-d30c-f111-8406-6045bdde1a47","LogicalName":"wp_channeltype"}',
} as const

export const LEAD_FORM_CONSENT = {
  FormFieldName: 'privacy',
  DataverseFieldName: 'msdynmkt_purposeid;channels;optinwhenchecked',
  DataverseFieldValue:
    'b94cbe05-5406-f111-8407-002248a22676;Email,Text;true',
} as const

export const PROVINCE_DYNAMICS_MAP: Record<string, string> = {
  agrigento: 'b6c8dd83-ba6b-f011-b4cc-000d3a69161a',
  alessandria: 'bcc8dd83-ba6b-f011-b4cc-000d3a69161a',
  ancona: 'bec8dd83-ba6b-f011-b4cc-000d3a69161a',
  aosta: 'c2c8dd83-ba6b-f011-b4cc-000d3a69161a',
  arezzo: 'cac8dd83-ba6b-f011-b4cc-000d3a69161a',
  ascoliPiceno: 'c6c8dd83-ba6b-f011-b4cc-000d3a69161a',
  asti: 'd0c8dd83-ba6b-f011-b4cc-000d3a69161a',
  avellino: 'd4c8dd83-ba6b-f011-b4cc-000d3a69161a',
  bari: 'dac8dd83-ba6b-f011-b4cc-000d3a69161a',
  barlettaAndriaTrani: 'ecc8dd83-ba6b-f011-b4cc-000d3a69161a',
  belluno: 'e2c8dd83-ba6b-f011-b4cc-000d3a69161a',
  benevento: 'e4c8dd83-ba6b-f011-b4cc-000d3a69161a',
  bergamo: 'dec8dd83-ba6b-f011-b4cc-000d3a69161a',
  biella: 'e0c8dd83-ba6b-f011-b4cc-000d3a69161a',
  bologna: 'e6c8dd83-ba6b-f011-b4cc-000d3a69161a',
  bolzano: 'f0c8dd83-ba6b-f011-b4cc-000d3a69161a',
  brescia: 'eac8dd83-ba6b-f011-b4cc-000d3a69161a',
  brindisi: 'e8c8dd83-ba6b-f011-b4cc-000d3a69161a',
  cagliari: 'f2c8dd83-ba6b-f011-b4cc-000d3a69161a',
  caltanissetta: '02c9dd83-ba6b-f011-b4cc-000d3a69161a',
  campobasso: 'f4c8dd83-ba6b-f011-b4cc-000d3a69161a',
  carboniaIglesias: '00c9dd83-ba6b-f011-b4cc-000d3a69161a',
  caserta: 'fac8dd83-ba6b-f011-b4cc-000d3a69161a',
  catania: '16c9dd83-ba6b-f011-b4cc-000d3a69161a',
  catanzaro: '18c9dd83-ba6b-f011-b4cc-000d3a69161a',
  chieti: 'fec8dd83-ba6b-f011-b4cc-000d3a69161a',
  como: '08c9dd83-ba6b-f011-b4cc-000d3a69161a',
  cosenza: '0ec9dd83-ba6b-f011-b4cc-000d3a69161a',
  cremona: '0cc9dd83-ba6b-f011-b4cc-000d3a69161a',
  crotone: '20cadd83-ba6b-f011-b4cc-000d3a69161a',
  cuneo: '06c9dd83-ba6b-f011-b4cc-000d3a69161a',
  enna: '3ac9dd83-ba6b-f011-b4cc-000d3a69161a',
  fermo: '02cadd83-ba6b-f011-b4cc-000d3a69161a',
  ferrara: 'fcc9dd83-ba6b-f011-b4cc-000d3a69161a',
  firenze: '00cadd83-ba6b-f011-b4cc-000d3a69161a',
  foggia: 'fec9dd83-ba6b-f011-b4cc-000d3a69161a',
  forliCesena: 'fac9dd83-ba6b-f011-b4cc-000d3a69161a',
  frosinone: '04cadd83-ba6b-f011-b4cc-000d3a69161a',
  genova: '06cadd83-ba6b-f011-b4cc-000d3a69161a',
  gorizia: '08cadd83-ba6b-f011-b4cc-000d3a69161a',
  grosseto: '0acadd83-ba6b-f011-b4cc-000d3a69161a',
  imperia: '0ecadd83-ba6b-f011-b4cc-000d3a69161a',
  isernia: '10cadd83-ba6b-f011-b4cc-000d3a69161a',
  laSpezia: 'dccadd83-ba6b-f011-b4cc-000d3a69161a',
  lameziaTerme: '2ccadd83-ba6b-f011-b4cc-000d3a69161a',
  laquila: 'c8c8dd83-ba6b-f011-b4cc-000d3a69161a',
  latina: '30cadd83-ba6b-f011-b4cc-000d3a69161a',
  lecce: '28cadd83-ba6b-f011-b4cc-000d3a69161a',
  lecco: '26cadd83-ba6b-f011-b4cc-000d3a69161a',
  livorno: '2acadd83-ba6b-f011-b4cc-000d3a69161a',
  lodi: '2ecadd83-ba6b-f011-b4cc-000d3a69161a',
  lucca: '32cadd83-ba6b-f011-b4cc-000d3a69161a',
  macerata: '36cadd83-ba6b-f011-b4cc-000d3a69161a',
  mantova: '3ccadd83-ba6b-f011-b4cc-000d3a69161a',
  massaCarrara: '40cadd83-ba6b-f011-b4cc-000d3a69161a',
  matera: '42cadd83-ba6b-f011-b4cc-000d3a69161a',
  medioCampidano: '04cbdd83-ba6b-f011-b4cc-000d3a69161a',
  messina: '38cadd83-ba6b-f011-b4cc-000d3a69161a',
  milano: '3acadd83-ba6b-f011-b4cc-000d3a69161a',
  modena: '3ecadd83-ba6b-f011-b4cc-000d3a69161a',
  monzaEBrianza: '34cadd83-ba6b-f011-b4cc-000d3a69161a',
  napoli: '44cadd83-ba6b-f011-b4cc-000d3a69161a',
  novara: '48cadd83-ba6b-f011-b4cc-000d3a69161a',
  nuoro: '4acadd83-ba6b-f011-b4cc-000d3a69161a',
  ogliastra: '4ccadd83-ba6b-f011-b4cc-000d3a69161a',
  olbiaTempio: '50cadd83-ba6b-f011-b4cc-000d3a69161a',
  oristano: '4ecadd83-ba6b-f011-b4cc-000d3a69161a',
  padova: '56cadd83-ba6b-f011-b4cc-000d3a69161a',
  palermo: '52cadd83-ba6b-f011-b4cc-000d3a69161a',
  parma: '62cadd83-ba6b-f011-b4cc-000d3a69161a',
  pavia: '6acadd83-ba6b-f011-b4cc-000d3a69161a',
  perugia: '5acadd83-ba6b-f011-b4cc-000d3a69161a',
  pesaroEUrbino: '68cadd83-ba6b-f011-b4cc-000d3a69161a',
  pescara: '58cadd83-ba6b-f011-b4cc-000d3a69161a',
  piacenza: '54cadd83-ba6b-f011-b4cc-000d3a69161a',
  pisa: '5ccadd83-ba6b-f011-b4cc-000d3a69161a',
  pistoia: '66cadd83-ba6b-f011-b4cc-000d3a69161a',
  pordenone: '5ecadd83-ba6b-f011-b4cc-000d3a69161a',
  potenza: '6ccadd83-ba6b-f011-b4cc-000d3a69161a',
  prato: '60cadd83-ba6b-f011-b4cc-000d3a69161a',
  ragusa: '98cadd83-ba6b-f011-b4cc-000d3a69161a',
  ravenna: '6ecadd83-ba6b-f011-b4cc-000d3a69161a',
  reggioCalabria: '86cadd83-ba6b-f011-b4cc-000d3a69161a',
  reggioEmilia: '96cadd83-ba6b-f011-b4cc-000d3a69161a',
  rieti: 'a4cadd83-ba6b-f011-b4cc-000d3a69161a',
  rimini: 'b4cadd83-ba6b-f011-b4cc-000d3a69161a',
  roma: 'accadd83-ba6b-f011-b4cc-000d3a69161a',
  rovigo: 'b8cadd83-ba6b-f011-b4cc-000d3a69161a',
  salerno: 'd4cadd83-ba6b-f011-b4cc-000d3a69161a',
  sassari: 'e0cadd83-ba6b-f011-b4cc-000d3a69161a',
  savona: 'e4cadd83-ba6b-f011-b4cc-000d3a69161a',
  siena: 'd6cadd83-ba6b-f011-b4cc-000d3a69161a',
  siracusa: 'decadd83-ba6b-f011-b4cc-000d3a69161a',
  sondrio: 'dacadd83-ba6b-f011-b4cc-000d3a69161a',
  sudSardegna: 'e2cadd83-ba6b-f011-b4cc-000d3a69161a',
  taranto: 'e6cadd83-ba6b-f011-b4cc-000d3a69161a',
  teramo: 'e8cadd83-ba6b-f011-b4cc-000d3a69161a',
  terni: 'f0cadd83-ba6b-f011-b4cc-000d3a69161a',
  torino: 'eccadd83-ba6b-f011-b4cc-000d3a69161a',
  trapani: 'eecadd83-ba6b-f011-b4cc-000d3a69161a',
  trento: 'eacadd83-ba6b-f011-b4cc-000d3a69161a',
  treviso: 'f4cadd83-ba6b-f011-b4cc-000d3a69161a',
  trieste: 'f2cadd83-ba6b-f011-b4cc-000d3a69161a',
  udine: 'f6cadd83-ba6b-f011-b4cc-000d3a69161a',
  varese: 'f8cadd83-ba6b-f011-b4cc-000d3a69161a',
  venezia: 'fecadd83-ba6b-f011-b4cc-000d3a69161a',
  verbanoCusioOssola: 'facadd83-ba6b-f011-b4cc-000d3a69161a',
  vercelli: 'fccadd83-ba6b-f011-b4cc-000d3a69161a',
  verona: '02cbdd83-ba6b-f011-b4cc-000d3a69161a',
  viboValentia: '08cbdd83-ba6b-f011-b4cc-000d3a69161a',
  vicenza: '00cbdd83-ba6b-f011-b4cc-000d3a69161a',
  viterbo: '06cbdd83-ba6b-f011-b4cc-000d3a69161a',
}

export const JOB_TITLE_DYNAMICS_MAP: Record<string, string> = {
  marketingAndBd: '016b9df3-d48c-f111-ab10-7c1e521fdb0d',
  owner: 'ef945711-077a-f111-ab0e-7c1e52773340',
  production: 'e5945711-077a-f111-ab0e-7c1e52773340',
  purchasing: 'e3945711-077a-f111-ab0e-7c1e52773340',
  quality: 'ed945711-077a-f111-ab0e-7c1e52773340',
  safety: 'e7945711-077a-f111-ab0e-7c1e52773340',
  sales: 'e9945711-077a-f111-ab0e-7c1e52773340',
  technical: 'eb945711-077a-f111-ab0e-7c1e52773340',
}

export const SECTOR_DYNAMICS_MAP: Record<string, string> = {
  automotive: '770f4429-ad6b-f011-b4cc-000d3ab483e3',
  chemical: '750f4429-ad6b-f011-b4cc-000d3ab483e3',
  constructions: '7f0f4429-ad6b-f011-b4cc-000d3ab483e3',
  electronics: '690f4429-ad6b-f011-b4cc-000d3ab483e3',
  energy: '810f4429-ad6b-f011-b4cc-000d3ab483e3',
  environment: '790f4429-ad6b-f011-b4cc-000d3ab483e3',
  foodAndBeverage: '6d0f4429-ad6b-f011-b4cc-000d3ab483e3',
  glassAndStone: '670f4429-ad6b-f011-b4cc-000d3ab483e3',
  healthcare: '6b0f4429-ad6b-f011-b4cc-000d3ab483e3',
  laboratoryResearch: '7b0f4429-ad6b-f011-b4cc-000d3ab483e3',
  metalFabrication: '730f4429-ad6b-f011-b4cc-000d3ab483e3',
  metalProduction: '6f0f4429-ad6b-f011-b4cc-000d3ab483e3',
  pulpAndPaper: '600f4429-ad6b-f011-b4cc-000d3ab483e3',
  rubberAndPlastic: '5e0f4429-ad6b-f011-b4cc-000d3ab483e3',
  textileAndLeather: '620f4429-ad6b-f011-b4cc-000d3ab483e3',
  other: '710f4429-ad6b-f011-b4cc-000d3ab483e3',
}

type LeadFormValues = {
  firstName: string
  lastName: string
  email: string
  subject: string
  phonePrefix: string
  phone: string
  companyName: string
  province: string
  jobTitle: string
  targetIndustry: string
  interestedIn: string
  existingCustomer: string
  privacy: boolean
}

export type CrmFieldMapping = {
  FormFieldName?: string
  DataverseFieldName: string
  DataverseFieldValue?: string
}

export function buildLookupValue(
  dynamicsMap: Record<string, string>,
  selectedValue: string,
  logicalName: string
): string | null {
  const id = dynamicsMap[selectedValue]
  if (!id) return null
  return JSON.stringify({ Id: id, LogicalName: logicalName })
}

export function buildLeadFormCrmMappings(
  values: LeadFormValues
): CrmFieldMapping[] {
  const mappings: CrmFieldMapping[] = [
    { DataverseFieldName: 'firstname', DataverseFieldValue: values.firstName },
    { DataverseFieldName: 'lastname', DataverseFieldValue: values.lastName },
    { DataverseFieldName: 'emailaddress1', DataverseFieldValue: values.email },
    { DataverseFieldName: 'companyname', DataverseFieldValue: values.companyName },
    { DataverseFieldName: 'subject', DataverseFieldValue: values.subject },
    { DataverseFieldName: 'wp_message', DataverseFieldValue: values.interestedIn },
  ]

  const mobilephone = `${values.phonePrefix}${values.phone}`.trim()
  if (mobilephone) {
    mappings.push({
      DataverseFieldName: 'mobilephone',
      DataverseFieldValue: mobilephone,
    })
  }

  const provinceValue = buildLookupValue(
    PROVINCE_DYNAMICS_MAP,
    values.province,
    'wp_province'
  )
  if (provinceValue) {
    mappings.push({
      DataverseFieldName: 'wp_provinceid',
      DataverseFieldValue: provinceValue,
    })
  }

  const jobTitleValue = buildLookupValue(
    JOB_TITLE_DYNAMICS_MAP,
    values.jobTitle,
    'wp_jobtitle'
  )
  if (jobTitleValue) {
    mappings.push({
      DataverseFieldName: 'wp_jobtitle',
      DataverseFieldValue: jobTitleValue,
    })
  }

  const sectorValue = buildLookupValue(
    SECTOR_DYNAMICS_MAP,
    values.targetIndustry,
    'wp_sector'
  )
  if (sectorValue) {
    mappings.push({
      DataverseFieldName: 'wp_sectorid',
      DataverseFieldValue: sectorValue,
    })
  }

  mappings.push({
    DataverseFieldName: 'optionset6361',
    DataverseFieldValue: values.existingCustomer === 'yes' ? '1' : '2',
  })

  mappings.push({ ...LEAD_FORM_CHANNEL_TYPE })
  mappings.push({ ...LEAD_FORM_CONSENT })

  return mappings
}
